import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FullscreenSvg = function FullscreenSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v9.767h1.674V1.674h8.093V0zM14.233 0v1.674h8.093v8.093H24V0zM22.326 22.326v-8.093H24V24h-9.767v-1.674zM0 14.233V24h9.767v-1.674H1.674v-8.093z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var Fullscreen = function Fullscreen(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FullscreenSvg
  }));
};